import "babel-polyfill"
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import {router} from './router'
import './utils/actionbtn'
import './plugins/antd.js'
import "./assets/icon/iconfont.css"
// import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import elColorPicker from 'el-color-picker'


// import '~ant-design-vue/dist/antd.less'; // 引入官方提供的 less 样式入口文件
// import 'your-theme-file.less'; // 用于覆盖上面定义的变量
Vue.config.productionTip = false
// Vue.use(Antd);
Vue.use(elColorPicker)
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.config.silent = true
Vue.use(elColorPicker)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
